import { render, staticRenderFns } from "./AccountingPage.vue?vue&type=template&id=784c7563&scoped=true&"
import script from "./AccountingPage.vue?vue&type=script&lang=ts&"
export * from "./AccountingPage.vue?vue&type=script&lang=ts&"
import style0 from "./AccountingPage.vue?vue&type=style&index=0&id=784c7563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c7563",
  null
  
)

export default component.exports